import React from "react";
import { BlogHeding } from "./Blogs/BlogHeding";
import { Paragraph } from "./Blogs/Paragraph";
import { SectionHeading } from "./Blogs/SectionHeading";
import { ListItem } from "./Blogs/ListItem";
import BlogTemplate from "./BlogTemplate";

const Blog11 = () => {
  return (
    <BlogTemplate>
      <BlogHeding title="Audino Annotation Tool" hedding="Launching Audio Annotation Tasks on Audino: A Comprehensive Guide" />

      <Paragraph explain="Whether you're working solo or with a team, Audino offers a streamlined process for managing your audio annotation projects. This guide walks you through creating an organization, setting up projects and tasks, assigning jobs, and tracking progress." />

      <SectionHeading sectionheading="Getting Started with Audino" />
      <Paragraph explain="Start by visiting app.audino.in and signing up. If you already have an account, simply log in. Your 'Personal Workshop' is your private space with full access, but you cannot invite collaborators here. For teamwork, create an organization." />

      <SectionHeading sectionheading="Creating an Organization for Team Collaboration" />
      <Paragraph explain="To collaborate with annotators, create an organization (e.g., 'demo_org'). Some fields are mandatory. Once done, your organization becomes active." />

      <SectionHeading sectionheading="Inviting Annotators to Your Organization" />
      <Paragraph explain="Invite members by entering their username and assigning roles: Workers (limited access), Supervisors (track progress), and Maintainers (full access). Typically, annotators are invited as Workers." />

      <SectionHeading sectionheading="Setting Up Your Project" />
      <ul className="space-y-2 text-white list-disc list-inside mt-4">
        <ListItem
          title="Step 1:"
          text="Navigate to the project section within your organization."
        />
        <ListItem
          title="Step 2:"
          text="Name your project (e.g., 'Audio Shakespeare as you like it')."
        />
        <ListItem
          title="Step 3:"
          text="Add labels such as 'Transcription' or 'Transcription Hindi'."
        />
        <ListItem
          title="Step 4:"
          text="Add attributes to labels like 'accent' or 'emotion'."
        />
        <ListItem
          title="Step 5:"
          text="Save your project after defining all labels and attributes."
        />
      </ul>

      <SectionHeading sectionheading="Creating a Task and Uploading Audios" />
      <ul className="space-y-2 text-white list-disc list-inside mt-4">
        <ListItem
          title="Step 1:"
          text="Click 'Add a new task' and give it a name."
        />
        <ListItem
          title="Step 2:"
          text="Select a subset type (e.g., train/test/validation)."
        />
        <ListItem
          title="Step 3:"
          text="Specify fields like 'transcription', 'accent', or 'gender'."
        />
        <ListItem
          title="Step 4:"
          text="Upload your audio files from local or cloud storage."
        />
      </ul>

      <SectionHeading sectionheading="Understanding Job Segmentation" />
      <Paragraph explain="Audino automatically splits uploaded audio into manageable segments. You can configure the segment length (1–10 mins). For ASR tasks, 1-minute segments are ideal." />

      <SectionHeading sectionheading="The Annotation Process" />
      <ul className="space-y-2 text-white list-disc list-inside mt-4">
        <ListItem
          title="Step 1:"
          text="Use horizontal or vertical zoom to examine audio."
        />
        <ListItem
          title="Step 2:"
          text="Create a region on the waveform to annotate."
        />
        <ListItem
          title="Step 3:"
          text="Select a label like 'Transcription English' or 'Transcription Hindi'."
        />
        <ListItem
          title="Step 4:"
          text="Transcribe or translate and apply the correct label."
        />
        <ListItem
          title="Step 5:"
          text="Save your annotations to mark the job as 'in progress'."
        />
      </ul>

      <SectionHeading sectionheading="Assigning and Tracking Jobs" />
      <Paragraph explain="From the task view, assign jobs to invited workers. They’ll only see their own jobs in their workspace. Owners or supervisors can monitor progress from the organization view." />

      <SectionHeading sectionheading="Completing an Annotation Job" />
      <Paragraph explain="Once a job is finished, the annotator marks it as 'completed'. The status updates and becomes visible to project owners or supervisors." />

      <SectionHeading sectionheading="Watch the Full Process!" />
      <div className="mt-4 mb-6">
        <Paragraph explain="For a visual walkthrough, check out the full process in the video below." />
        {/* Embed your video here */}
        <iframe src="https://drive.google.com/file/d/1rmBpWcEABGDF_brjaC6flyWND86di_1I/preview" title="Audino Annotation Tool Walkthrough" width="100%" height="700" allow="autoplay"></iframe>
      </div>
    </BlogTemplate>
  );
};

export default Blog11;
